theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector("header");
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (!headerStickyWrapper || headerStickyTargetList.length === 0) return;

    function isDesktop() {
      return window.innerWidth >= 750;
    }

    // Ervan uitgaande dat TopOffset een externe helper functie is die beschikbaar is in je thema.
    // Als deze niet bestaat, kun je onderstaande regel gebruiken:
    // function TopOffset(el) { const rect = el.getBoundingClientRect(); return { top: rect.top + window.scrollY, left: rect.left + window.scrollX }; }

    headerStickyTargetList.forEach((headerStickyTarget) => {
      let stickyHeight = headerStickyTarget.offsetHeight;
      
      // We slaan de initiële positie van het element BINNEN de header op.
      // Voor de bovenste balk is dit 0, voor het menu is dit de hoogte van de balk erboven.
      let elementOffset = headerStickyTarget.offsetTop;

      function handleSticky() {
        // 1. Mobile Check
        if (!isDesktop()) {
          headerStickyTarget.classList.remove("sticky");
          headerStickyWrapper.style.paddingBottom = "0px";
          return;
        }

        // 2. Desktop Check: Negeer elementen met 'not--sticky-on-desktop'
        if (headerStickyTarget.classList.contains('not--sticky-on-desktop')) {
           headerStickyTarget.classList.remove("sticky");
           // Zorg dat we geen padding toevoegen voor dit element
           return; 
        }

        // 3. Update stickyHeight en offsets (voor het geval de browser geresized is)
        // We moeten dit dynamisch houden voor als de balk erboven van grootte verandert
        if (!headerStickyTarget.classList.contains("sticky")) {
            elementOffset = headerStickyTarget.offsetTop;
            stickyHeight = headerStickyTarget.offsetHeight;
        }

        // 4. Bepaal het trigger punt
        let StickyTargetElement = TopOffset(headerStickyWrapper);
        let WrapperTopOffset = StickyTargetElement.top;

        // HET BELANGRIJKSTE STUK:
        // Het trigger punt is de bovenkant van de wrapper + de afstand van het menu tot die bovenkant.
        let scrollThreshold = WrapperTopOffset + elementOffset;

        if (window.scrollY > scrollThreshold) {
          headerStickyTarget.classList.add("sticky");
          headerStickyWrapper.style.paddingBottom = stickyHeight + "px";
        } else {
          headerStickyTarget.classList.remove("sticky");
          headerStickyWrapper.style.paddingBottom = "0px";
        }
      }

      window.addEventListener("scroll", handleSticky);
      
      window.addEventListener("resize", function () {
        // Bij resize resetten we even de sticky class om de originele offsetTop goed te kunnen meten
        headerStickyTarget.classList.remove("sticky");
        stickyHeight = headerStickyTarget.offsetHeight;
        elementOffset = headerStickyTarget.offsetTop;
        handleSticky();
      });

      handleSticky();
    });
  }

  return ScrollSticky;
})();